import React from 'react';
import { Photo } from './Photo';
import TwoPhotosWrapper from './TwoPhotosWrapper';
import { observer } from 'mobx-react';

interface IProps {
  leftUrl: string;
  rightUrl: string;
  onLeftPhotoClick?: () => any;
  onRightPhotoClick?: () => any;
  isDisabled?: boolean;
}

const TwoPhotos: React.FC<IProps> = observer((props) => {
  return (
    <TwoPhotosWrapper>
      <Photo isDisabled={props.isDisabled} onClick={props.onLeftPhotoClick} src={props.leftUrl} />
      <Photo isDisabled={props.isDisabled} onClick={props.onRightPhotoClick} src={props.rightUrl} />
    </TwoPhotosWrapper>
  );
});

export default TwoPhotos;
